<template>
  <div class="users-layout">
    <default-box
        :loader="loading">
      <div class="d-flex justify-content-between align-items-center mb-10">
        <div class="row col-md-8 align-items-center justify-content-start row-column">
          <default-title :h_tag="'h3'">
            {{ $t('trashed.' + taleTitle) }}
          </default-title>
        </div>
      </div>
      <tables-slot
          :empty_spacer="loading"
          @paginationFetch="fillData"
          @popstateEvent="getTrashedList(this.$route.params.id)"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
          <td class="w-0 text-nowrap">{{ $t('tables.edit') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="item in list">
            <td class="w-0 text-nowrap">
              {{ item.id }}
            </td>
            <td class="w-0 text-nowrap">
              {{ item.title ?? item.name }}
            </td>
            <td class="w-0 text-nowrap">
              <span
                  @click="restore(item.id)"
                  class="d-inline-block px-10 py-10 cursor_pointer">
                <upload-icon/>
              </span>
<!--              <span-->
<!--                  @click="forceDelete(item.id)"-->
<!--                  class="d-inline-block px-10 py-10 cursor_pointer">-->
<!--                <trash-icon/>-->
<!--              </span>-->
              <router-link v-if="getRouteName()"
                  :to="{
                    name: getRouteName(),
                    params: { id: item.id },
                  }"
                  class="d-inline-block px-10 py-10"
                  >
                <edit-icon/>
              </router-link>
            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import {axiosArticles, axiosBelts, axiosTrash} from "../../../helpers/axios_requests";
import {REPLACE_IN_QUERY, REPLACE_STATE} from "../../../helpers/url_helper";
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import Switcher from "../../small_components/Switcher.vue";
import EditIcon from "../../icons/EditIcon.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import CloseIcon from "../../icons/CloseIcon.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import TrashIcon from "../../icons/TrashIcon.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import UploadIcon from "../../icons/UploadIcon.vue";
import DefaultTitle from "../../small_components/DefaultTitle.vue";

export default {
  name: 'TrashedLayout',
  mixins: [routes_mixin],
  components: {
    DefaultTitle,
    UploadIcon,
    DefaultSelect,
    TrashIcon,
    LogoutIcon,
    DefaultButton,
    CloseIcon,
    DefaultInput,
    SearchInput,
    DefaultBox,
    EditIcon,
    Switcher,
    TablesSlot,
    RouterLinkTo,
  },
  computed: {

  },
  beforeMount() {
    this.getTrashedList(this.$route.params.id);
  },
  data() {
    return {
      list: [],
      trashed: [],
      routeName: false,
      pagination: [],
      loading: false,
      search: '',
      taleTitle: 'default_title',
    }
  },
  methods: {
    fillData({collection, trashed, pagination}) {
      this.list = collection || []
      this.trashed = trashed || []
      this.routeName = trashed.route_name || false
      this.pagination = pagination || []
      this.taleTitle = trashed.table ?? 'default_title'
    },

    getTrashedList(id) {
      this.loading = true
      axiosTrash.trashedItems({trashed: id})
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },

    getRouteName() {
      return this.routeName;
    },

    forceDelete(id) {

    },

    restore(id) {
      this.loading = true
      axiosTrash.restore({trashed: this.$route.params.id, id: id})
          .then(r => {

          })
          .finally(() => {
            this.getTrashedList(this.$route.params.id)
          })
    }
  }
}
</script>
